"use client";

import { useEffect, useState } from "react";
import styles from "./cookie.module.css";
import axios from "axios";
import { getToken } from "../../utils/auth";
import { useUser } from "../../Context/UserContext";

export default function CookieConsent({isRTL}) {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [cookieConsent, setCookieConsent] = useState(false);
  const token = getToken();
  const { userData, fetchUserData } = useUser();

  useEffect(() => {
    const checkConsent = async () => {
      try {
        // Check session storage first for immediate response
        const sessionConsent = sessionStorage.getItem("cookies") === "true";

        // If no session consent, check API
        if (!sessionConsent) {
          const apiConsent = await fetchUserConsent();
          if (apiConsent) {
            sessionStorage.setItem("cookies", "true");
          }
          setShowModal(!apiConsent);
        } else {
          setShowModal(false);
        }
      } catch (error) {
        console.error("Error in consent check:", error);
        setShowModal(true); // Show modal if error occurs (conservative)
      } finally {
        setIsLoading(false);
      }
    };

    checkConsent();
  }, []);

  const fetchUserConsent = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.data.isCookieConsent;
    } catch (error) {
      console.error("Failed to fetch consent status:", error);
      return false; // Default to false if API fails
    }
  };

  const updateConsent = async (accepted) => {
    try {
      setShowModal(false);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/user/cookie-consent`,
        {
          isCookieConsent: accepted,
          cookiePolicyVersion: "v1.0",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      sessionStorage.setItem("cookies", true);
      fetchUserData();
    } catch (error) {
      console.error("Error updating consent:", error);
      setShowModal(true); // Re-show modal if update fails
    }
  };

  if (isLoading || !showModal) return null;

  return (
    <div className={styles.cookieContainer} dir={isRTL ? "rtl" : "ltr"}>
      <div className={styles.cookieContent}>
        <div className={styles.textGroup}>
          <h3 className={styles.title}>We Value Your Privacy</h3>
          <p className={styles.description}>
            We use cookies to enhance your experience. By continuing to visit
            this site, you agree to our use of cookies.
          </p>
        </div>
        <div className={styles.buttonGroup}>
          <button
            onClick={() => updateConsent(false)}
            className={styles.declineBtn}
          >
            Reject
          </button>
          <button
            onClick={() => updateConsent(true)}
            className={styles.acceptBtn}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
